import styled from 'styled-components';
import colors from '../../theme/colors';

export const CoverImageWrapper = styled.div`
  height: 35vh;
  width: 100%;
  background: ${colors.primaryHover};
  position: relative;
`;

export const CoverImageImg = styled.img`
  position: absolute;
  inset: 0;
  object-fit: cover;
  opacity: 0.5;
  width: 100%;
  height: 100%;
`;
